// Global Theme Variables

export const GRADIENTS = {
  primary: 'linear-gradient(135deg, #149F9C 0%, #1ab3af 100%)',
  secondary: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
  success: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
  danger: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
  warning: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
  info: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
};

export const COLORS = {
  primary: '#149F9C',
  primaryDark: '#0d7a77',
  secondary: '#6c757d',
  success: '#28a745',
  danger: '#dc3545',
  warning: '#ffc107',
  info: '#17a2b8',
};

export default { GRADIENTS, COLORS };
